import { takeEvery, fork, put, all, call, select } from "redux-saga/effects";

import UsersService from "./service";
import {UserActionTypes} from "./actionTypes";
import {
    getUsersParentError, getUsersParentExelError, getUsersParentExelSuccessful,
    getUsersParentSuccessful,
    getUsersProfessionalsError,
    getUsersProfessionalsSuccessful,
    setUsersProfessionalQuery,
    setUsersParentQuery
} from "./actions";

// Selectors to get the users query state from the Redux store.
export const getUsersProfessionalQuery = state => state.Users.professionalQuery;
export const getUsersParentQuery = state => state.Users.parentQuery;

function* getProfessionals({payload}) {
    try {
        // Get the current query from the Redux store.
        const storedQuery = yield select(getUsersProfessionalQuery);
        // The payload from the action can override the stored query for this specific call.
        const finalPayload = { ...storedQuery, ...payload?.payload };
        const response = yield call(UsersService.getUsersByParams, finalPayload);
        yield put(getUsersProfessionalsSuccessful(response));
        yield put(setUsersProfessionalQuery(finalPayload));
    } catch (error) {
        yield put(getUsersProfessionalsError(error));
    }
}
function* getParents({payload}) {
    try {
        // Get the current query from the Redux store.
        const storedQuery = yield select(getUsersParentQuery);
        // The payload from the action can override the stored query for this specific call.
        const finalPayload = { ...storedQuery, ...payload?.payload };
        const response = yield call(UsersService.getUsersByParams, finalPayload);
        yield put(getUsersParentSuccessful(response));
        yield put(setUsersParentQuery(finalPayload));
    } catch (error) {
        yield put(getUsersParentError(error));
    }
}

function* getParentsExel() {
    try {
        const response = yield call(UsersService.getParentsExel, {});
        yield put(getUsersParentExelSuccessful(response));
    } catch (error) {
        yield put(getUsersParentExelError(error));
    }
}


export function* watchGetProfessionalsUsers() {
    yield takeEvery(UserActionTypes.USERS_PROFESSIONAL_LIST_GET, getProfessionals);
}

export function* watchGetParentUsers() {
    yield takeEvery(UserActionTypes.USERS_PARENT_LIST_GET, getParents);
}
export function* watchGetParentExel() {
    yield takeEvery(UserActionTypes.USERS_PARENT_LIST_GET_EXEL, getParentsExel);
}

function* usersSaga() {
    yield all([
        fork(watchGetProfessionalsUsers),
        fork(watchGetParentUsers),
        fork(watchGetParentExel),
    ]);
}

export default usersSaga;
